import React, { useState } from "react";
import "./Game_tabs_Section.css";
import Game_History from "./Game_History/Game_History";
import My_History from "./My_History/My_History";
import Chart from "./Chart/Chart";

function Game_tabs_Section() {
  const [activeTab, setActiveTab] = useState("gameHistory");

  return (
    <section className="game_history_section">

      {/* Tabs */}
      <div className="tabs">
        <button
          className={activeTab === "gameHistory" ? "active" : ""}
          onClick={() => setActiveTab("gameHistory")}
        >
          Game History
        </button>

        <button
          className={activeTab === "chart" ? "active" : ""}
          onClick={() => setActiveTab("chart")}
        >
          Chart
        </button>

        <button
          className={activeTab === "myHistory" ? "active" : ""}
          onClick={() => setActiveTab("myHistory")}
        >
          My History
        </button>
      </div>

      {activeTab === "gameHistory" && (
       <Game_History/>
      )}

      {activeTab === "chart" && (
        <div className="tab_empty">
          <Chart/>
        </div>
      )}

      {activeTab === "myHistory" && (
        <div className="tab_empty">
          <My_History/>
        </div>
      )}

    </section>
  );
}

export default Game_tabs_Section;